/**
 * Get runtime configuration value
 * Falls back to build-time process.env if runtime config is not available
 */
export function getConfig(key: string): string | undefined {
  // Check if runtime config is available
  if (typeof window !== 'undefined' && (window as any).APP_CONFIG) {
    const value = (window as any).APP_CONFIG[key]
    // If value contains ${...}, it means it wasn't replaced, fall back to process.env
    if (value && !value.includes('${')) {
      return value
    }
  }
  // Fall back to build-time environment variable
  return process.env[key]
}
